
export default {

};



// WEBPACK FOOTER //
// ./src/library/settings.es6